export default class Global {
  static apiUrl = process.env.NEXT_PUBLIC_API_URL;
  static imageUrl = process.env.NEXT_PUBLIC_IMAGE_URL;
  static paypalClientId = process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID;
  static fileUploadUrlPrefix =
    process.env.NODE_ENV === "development"
      ? ""
      : process.env.NEXT_PUBLIC_API_URL;
  static domainUrl = process.env.NEXT_PUBLIC_DOMAIN_URL;
}
